import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0505 from "../../../lesson/course-05/lesson-05/lesson";
import lesson0506 from "../../../lesson/course-05/lesson-06/lesson";
import lesson0511 from "../../../lesson/course-05/lesson-11/lesson";
import lesson0513 from "../../../lesson/course-05/lesson-13/lesson";
import lesson0514 from "../../../lesson/course-05/lesson-14/lesson";
import lesson0529 from "../../../lesson/course-05/lesson-29/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2fd8230e-999d-41c0-9c97-0360c4efafac",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0505),
    lesson: lesson0505,
  },
  {
    id: "4eb59250-5ab2-45d6-872a-25ff5c651ea2",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
  {
    id: "e6fe09a8-384c-4ea4-9018-5f543f712bc3",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0511),
    lesson: lesson0511,
  },
  {
    id: "0be1a7ef-2a89-4a8f-a1fb-029bc38b85d9",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0513),
    lesson: lesson0513,
  },
  {
    id: "07fb17c4-89ac-43c4-96c8-0acd32d6ba94",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0514),
    lesson: lesson0514,
  },
  {
    id: "f5eaddee-c5b2-428e-978f-20c495244c2d",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0529),
    lesson: lesson0529,
  },
];

export default lessonLinks;
